export const GetNobatPrefrences = () => {
  const prefrences = localStorage.getItem('nobat_prefrence')
    ? JSON.parse(localStorage.getItem('nobat_prefrence'))
    : '';

  return prefrences;
};
